export default __webpack_public_path__ + "static/media/Anne-Sophie@2x.aac69fff.jpg";